import { Component, inject, OnDestroy, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BodyStyleService } from '@shared/services/body-style.service';
import { AuthLogin } from '../auth/login/login';
import { ClickOutsideDirective } from '@shared/directives/click-out-side.directive';

@Component({
  selector: 'app-home',
  imports: [RouterModule, AuthLogin, ClickOutsideDirective],
  templateUrl: './home.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './home.css',
})
export class Home implements OnInit, OnDestroy {
  // servicios
  showLogin = signal(false);

  scrollTo(id: string) {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  private readonly HOME_CLASS = 'home-background';
  private bodyStyleService = inject(BodyStyleService);
  ngOnInit() {
    this.bodyStyleService.addClass(this.HOME_CLASS);
  }
  ngOnDestroy() {
    this.bodyStyleService.removeClass(this.HOME_CLASS);
  }
}
